const LEGAL_COMPANY_NAME = "Innovally";
const LEGAL_COMPANY_CNPJ = "[CNPJ a confirmar com assessoria jurídica]";
const LEGAL_COMPANY_CONTACT = "contato@innovally.com.br";

const LEGAL_DPO_EMAIL = import.meta.env.VITE_LEGAL_DPO_EMAIL ?? "privacidade@innovally.com.br";

const LEGAL_LAST_UPDATED = import.meta.env.VITE_LEGAL_LAST_UPDATED ?? "05/09/2026";

const LEGAL_VERSION = "1.0.0";

export {
  LEGAL_COMPANY_CNPJ,
  LEGAL_COMPANY_CONTACT,
  LEGAL_COMPANY_NAME,
  LEGAL_DPO_EMAIL,
  LEGAL_LAST_UPDATED,
  LEGAL_VERSION,
};
